import styled from 'styled-components'

export const TopCardWrapper = styled.div`
  position: relative;
  z-index: 2;
  @media screen and (min-width: 768px) {
    margin-top: -150px;
  }
`
